import React from "react";
import sImg1 from "../../images/event/flower.svg";
import sLeftImg from "../../images/event/event-left.jpg";


interface EventItem {
  title: string;
  etitle1: string;
  etitle2: string;
  etitle3: string;
  etitle4: string;
  etitle5: string;
  etitle6: string;
  etitle7: string;
  etitle8: string;
  time1: string;
  time2: string;
  time3: string;
  time4: string;
  time5: string;
  time6: string;
  time7: string;
  time8: string;
}

interface EventSectionProps {
  className?: string;
}

const Events: EventItem[] = [
  /* {
    title: "The Day Before",
    etitle1: "Event One",
    etitle2: "Event Two",
    etitle3: "Event Three",
    time1: "03:00 PM",
    time2: "05:00 PM",
    time3: "08:00 PM",
  }, */
  {
    title: "El día de la Boda",
    etitle1: "Ceremonia Religiosa",
    etitle2: "Coctel de Bienvenida",
    etitle3: "Banquete",
    etitle4: "Brindis / Baile nupcial",
    etitle5: "Se abre la pista de baile",
    etitle6: "Partida de pastel",
    etitle7: "Tornaboda",
    etitle8: "Fin del evento",
    time1: "02:00 PM",
    time2: "03:00 PM",
    time3: "04:00 PM",
    time4: "05:30 PM",
    time5: "06:00 PM",
    time6: "08:30 PM",
    time7: "10:30 PM",
    time8: "11:00 PM",
  }
  // },
  // {
  //   title: "The Day After",
  //   etitle1: "Event One",
  //   etitle2: "Event Two",
  //   etitle3: "Event Three",
  //   time1: "03:00 PM",
  //   time2: "05:00 PM",
  //   time3: "08:00 PM",
  // },
];

const EventSection: React.FC<EventSectionProps> = ({ className }) => {
  return (
    <section className={`wpo-event-section ${className || ""}`}>
      <div className="container-fluid">
        <div className="row">
          <div className="col col-lg-6 col-md-12 col-12">
            <div className="event-left-image">
              <img src={sLeftImg} alt="Event section left" />
            </div>
          </div>
          <div className="col col-lg-6 col-md-12 col-12">
            <div className="event-right section-padding">
              <div className="event-right-wrap">
                <div className="event-title">
                  <div className="icon">
                    <img src={sImg1} alt="Event section flower icon" />
                  </div>
                  <h2 className="poort-text poort-in-right">Itinerario</h2>
                </div>
                {Events.map((event, index) => (
                  <div className="event-right-items" key={index}>
                    <h3>{event.title}</h3>
                    <ul>
                      <li>
                        {event.etitle1} <span>{event.time1}</span>
                      </li>
                      <li>
                        {event.etitle2} <span>{event.time2}</span>
                      </li>
                      <li>
                        {event.etitle3} <span>{event.time3}</span>
                      </li>
                      <li>
                        {event.etitle4} <span>{event.time4}</span>
                      </li>
                      <li>
                        {event.etitle5} <span>{event.time5}</span>
                      </li>
                      <li>
                        {event.etitle6} <span>{event.time6}</span>
                      </li>
                      <li>
                        {event.etitle7} <span>{event.time7}</span>
                      </li>
                      <li>
                        {event.etitle8} <span>{event.time8}</span>
                      </li>
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventSection;
